var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9279 7.05249C23.8694 5.77515 23.6666 4.90283 23.3699 4.13965C23.0687 3.33893 22.5963 2.61365 21.9858 2.01416C21.3865 1.40369 20.6611 0.931091 19.8604 0.6297C19.097 0.333252 18.2249 0.130554 16.9475 0.0725098C15.6678 0.013916 15.2589 0 12 0C8.74109 0 8.33221 0.013916 7.05249 0.0721435C5.77515 0.130554 4.90302 0.333435 4.13965 0.630066C3.33893 0.931274 2.61365 1.40369 2.01416 2.01416C1.40369 2.61346 0.931091 3.33875 0.6297 4.13947C0.333252 4.90283 0.130554 5.77515 0.0725098 7.05231C0.013916 8.33221 0 8.74091 0 11.9998C0 15.2589 0.013916 15.6678 0.0725098 16.9475C0.130737 18.2247 0.333618 19.097 0.630249 19.8604C0.931458 20.6609 1.40387 21.3864 2.01434 21.9857C2.61365 22.5961 3.33911 23.0685 4.13983 23.3698C4.90302 23.6666 5.77533 23.8693 7.05267 23.9277C8.33258 23.9861 8.74127 23.9998 12.0002 23.9998C15.2591 23.9998 15.668 23.9861 16.9477 23.9277C18.225 23.8693 19.0972 23.6666 19.8605 23.3698C21.4724 22.7465 22.7466 21.4722 23.3699 19.8604C23.6667 19.097 23.8694 18.2247 23.9279 16.9475C23.9861 15.6676 24 15.2589 24 12C24 8.74091 23.9861 8.33221 23.9279 7.05249ZM21.7678 16.8492C21.7145 18.0192 21.5189 18.6546 21.3547 19.0774C20.9509 20.124 20.1238 20.9511 19.0772 21.3549C18.6544 21.5191 18.019 21.7147 16.849 21.7679C15.5839 21.8258 15.2043 21.8379 12 21.8379C8.79547 21.8379 8.41608 21.8258 7.15082 21.7679C5.98096 21.7147 5.34558 21.5191 4.92261 21.3549C4.40149 21.1624 3.92999 20.8557 3.54291 20.4571C3.14429 20.07 2.83759 19.5987 2.64514 19.0774C2.4809 18.6546 2.28534 18.0192 2.23206 16.8492C2.17438 15.5839 2.16211 15.2043 2.16211 12.0002C2.16211 8.79584 2.17438 8.41644 2.23206 7.151C2.28552 5.98096 2.4809 5.34558 2.64514 4.92279C2.83759 4.40149 3.14447 3.92999 3.54291 3.54291C3.92999 3.14429 4.40149 2.83759 4.92279 2.64532C5.34558 2.4809 5.98096 2.28552 7.151 2.23206C8.41626 2.17438 8.79584 2.16211 12 2.16211H11.9998C15.204 2.16211 15.5836 2.17438 16.849 2.23224C18.019 2.28552 18.6542 2.48108 19.0772 2.64532C19.5983 2.83777 20.0698 3.14447 20.4569 3.54291C20.8555 3.92999 21.1622 4.40149 21.3545 4.92279C21.5189 5.34558 21.7145 5.98096 21.7678 7.151C21.8254 8.41626 21.8377 8.79584 21.8377 12C21.8377 15.2043 21.8256 15.5837 21.7678 16.8492Z",
    fill: "url(#instagram_paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5.83789C8.59674 5.83789 5.83789 8.59692 5.83789 12.0001C5.83789 15.4033 8.59674 18.1622 11.9999 18.1622C15.4033 18.1622 18.1622 15.4033 18.1622 12.0001C18.1622 8.59692 15.4033 5.83789 11.9999 5.83789ZM11.9999 16.0001C9.79095 15.9999 8 14.2091 8.00018 11.9999C8.00018 9.79095 9.79095 8 12.0001 8C14.2093 8.00018 16.0001 9.79095 16.0001 11.9999C16.0001 14.2091 14.2091 16.0001 11.9999 16.0001Z",
    fill: "url(#instagram_paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8454 5.59442C19.8454 6.38965 19.2007 7.03436 18.4055 7.03436C17.61 7.03436 16.9653 6.38965 16.9653 5.59442C16.9653 4.79901 17.61 4.1543 18.4055 4.1543C19.2007 4.1543 19.8454 4.79901 19.8454 5.59442Z",
    fill: "url(#instagram_paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_paint0_linear",
    x1: 2.01404,
    y1: 21.9858,
    x2: 21.986,
    y2: 2.01384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D800B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_paint1_linear",
    x1: 7.64276,
    y1: 16.3573,
    x2: 16.3573,
    y2: 7.64276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_paint2_linear",
    x1: 17.3872,
    y1: 6.61255,
    x2: 19.4236,
    y2: 4.57613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9e4dc81f.svg";
export { ForwardRef as ReactComponent };